import PropTypes from "prop-types";
import s from "./Expandable.module.css";

export default function Expandable({ open, id, children }) {
  return (
    <div
      id={id}
      className={`${s.expandBody}${open ? ` ${s.expandBodyOpen}` : ""}`}
    >
      <div className={s.expandBodyInner}>
        <div>{children}</div>
      </div>
    </div>
  );
}

Expandable.propTypes = {
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  children: PropTypes.node,
};
